module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "y-collapse-item",
    class: _vm.show ? 'y-collapse-open' : 'y-collapse-close'
  }, [_c('div', {
    staticClass: "y-collapse-header",
    on: {
      "click": _vm.handle
    }
  }, [_c('y-svg', {
    attrs: {
      "type": "arrow",
      "width": 12
    }
  }), _vm._v("\n        " + _vm._s(_vm.header) + "\n    ")], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "y-collapse-content"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "y-collapse-content"
  }, [_c('div', {
    staticClass: "y-collapse-content-box"
  }, [_vm._t("default")], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-f51c3d6c!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/collapse/panel.vue
// module id = 504
// module chunks = 27